/**
 * From 'snake_to_normal' to 'Snake To Normal'
 */
export const snakeToCapitalized = (str: string) => (str || '')
  .replace(/([-_]\w)/g, (g) => ` ${g[1].toUpperCase()}`)
  .replace(str[0], str[0].toUpperCase());
